import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import MesFestivoImpl from './MesFestivoImpl';
import { apiFestivosService } from 'services/apiFestivosService';

const AnnoFestivo = (props) => {
    
    
    const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    // Petición para obtener todos los festivos del año y agrupar por mes
    const [festivosPorMes, setFestivosPorMes] = useState(Array.from({length:12}, ()=>[]));
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
      const fetchFestivosAnno = async () => {
        if(!props.anno || !props.centroId) return;
        try{
          const response = await apiFestivosService.getByAnnoAndCentroId(props.anno, props.centroId);
          const mesesUpper = meses.map(m => m.toUpperCase());
          const agrupado = Array.from({length:12}, ()=>[]);
          (response || []).forEach(f => {
            const idx = mesesUpper.indexOf((f.mes || '').toString());
            if(idx >= 0) agrupado[idx].push(f);
          });
          setFestivosPorMes(agrupado);
        }catch(err){
          setFestivosPorMes(Array.from({length:12}, ()=>[]));
        }
      }

      fetchFestivosAnno();
    }, [props.anno, props.centroId, props.update, refreshKey]);

    const handleChildChange = () => setRefreshKey(k => k + 1);

  return (
    <>
        <Row className="mt-2">
        {meses.map((mes, index) =>{
            return (
                <Col  xl="4"  className="mb-5  " >
                  <MesFestivoImpl key={mes} anno={props.anno} mes={index} nombreMes={mes} centroId={props.centroId} update={props.update} diasFestivos={festivosPorMes[index]} onChange={handleChildChange}></MesFestivoImpl>
        </Col>
            )
        })}
        
      </Row>
    </>
  )
}

export default AnnoFestivo